import * as Yup from "yup";

export const LoginSchema = Yup.object({
  email: Yup.string().min(5,"login.block-form.error.username-min").required("login.block-form.error.username-required"),
  password: Yup.string().required("login.block-form.error.password-required"),
  available: Yup.boolean()
});
